import { QueryClient } from "react-query";

import type { LineStyle } from "components/project/shapefiles/shapefiles.constants";

import {
  SHAPEFILE_LIST_QUERY_KEYS,
  Shapefile
} from "../../queries/useShapefilesListQuery";

interface UpdateShapefilePropertiesCacheParams {
  queryClient: QueryClient;
  shapefileGeomIds: string[];
  update: {
    color?: string;
    opacity?: number;
    thickness?: number;
    strokeColor?: string;
    lineStyle?: LineStyle;
    fillPattern?: string;
  };
}

export function updateShapefilePropertiesCache({
  queryClient,
  shapefileGeomIds,
  update
}: UpdateShapefilePropertiesCacheParams): void {
  queryClient.setQueriesData<{ data: Shapefile[] }>(
    {
      predicate: (query) =>
        query.queryKey[0] === SHAPEFILE_LIST_QUERY_KEYS.currentProjectShapefileList
    },
    (oldData) => {
      if (!oldData?.data) return oldData;

      return {
        ...oldData,
        data: oldData.data.map((shapefile) => ({
          ...shapefile,
          features: shapefile.features.map((feature) =>
            shapefileGeomIds.includes(feature.shapefileGeomId)
              ? {
                  ...feature,
                  ...update
                }
              : feature
          )
        }))
      };
    }
  );
}
